import { render } from "./CurrencyListComponent.vue?vue&type=template&id=b87b873e"
import script from "./CurrencyListComponent.vue?vue&type=script&lang=js"
export * from "./CurrencyListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Currency/CurrencyListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b87b873e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b87b873e', __exports__)) {
    api.reload('b87b873e', __exports__)
  }
  
  module.hot.accept("./CurrencyListComponent.vue?vue&type=template&id=b87b873e", () => {
    api.rerender('b87b873e', render)
  })

}


export default __exports__